import { getScope1Emissions } from '../../../api/emissionsApi';
import { getHistoricalReport } from '../../../api/historicalReportsApi';
import { createEmptyScope1, normalizeScope1, normalizeHistoricalScope1 } from '../model/emissionScreens';
import useEmissionScreen from './useEmissionScreen';

export default function useScope1Emissions() {
  return useEmissionScreen({
    request: getScope1Emissions,
    normalize: normalizeScope1,
    createEmpty: createEmptyScope1,
    historicalRequest: getHistoricalReport,
    normalizeHistorical: normalizeHistoricalScope1,
  });
}
